import { render, staticRenderFns } from "./WhatBEX.vue?vue&type=template&id=1cdd062e&"
import script from "./WhatBEX.vue?vue&type=script&lang=js&"
export * from "./WhatBEX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports